<tec-modal
    [isVisible]="true"
    [title]="'PROCESSES.DETAIL.CHANGE_STATUS_MODAL_TITLE' | translate"
    [buttonPrimaryLabel]="'BUTTON.UPDATE' | translate"
    [buttonSecondaryLabel]="'BUTTON.CANCEL' | translate"
    (closeEvent)="closeModal($event)"
>
    <ng-container body [formGroup]="form">
        @if (errorMsg) {
            <tec-alert status="error" [msg]="errorMsg" (closeAlert)="errorMsg = ''" />
        }

        <tec-form-group [label]="'FILTERS.STATE' | translate" [errorMsg]="reactiveFormService.hasMsgError(form.get('status'))">
            <tec-toggle
                formControlName="status"
                [options]="options"
                [multiple]="false"
                [requireSelection]="true"
            />
        </tec-form-group>
        <tec-form-group
            [label]="'PROCESSES.DETAIL.CHANGE_STATUS_REASONS_LABEL' | translate"
            [errorMsg]="reactiveFormService.hasMsgError(form.get('reasons'))"
        >
            <tec-textarea
                formControlName="reasons"
                [hasError]="reactiveFormService.hasError(form.get('reasons'))"
                [placeholder]="'PROCESSES.DETAIL.CHANGE_STATUS_REASONS_PLACEHOLDER' | translate"
                [maxlength]="500"
            />
        </tec-form-group>
    </ng-container>
</tec-modal>
